import * as React from 'react';

import './SgLogo.scss';

interface ISgLogoProps {
    src: string;
    href: string;
    isCollapsible?: boolean;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    alt?: string;
}

export const SgLogo = ({ href, alt, src, isCollapsible, onClick, ...props }: ISgLogoProps) => {
    return (
        <a className="sglogo__wrapper" {...(!isCollapsible ? { href } : { onClick })} {...props}>
            <img src={src} alt={alt} className="sglogo__image" />
        </a>
    );
};
